import { useAuthStore } from '@/stores/authStore';
import { BPE_EN_SERVICE } from '@/constants/activites';
import { FlotteToupiesPage } from './beton/FlotteToupiesPage';
import { FlotteCamionsPage } from './transport/FlotteCamionsPage';

/**
 * Dispatcher Flotte selon le métier de la filiale connectée :
 * - beton             → FlotteToupiesPage (camions malaxeurs BPE)
 * - transport_minier  → FlotteCamionsPage (camions miniers + équipes)
 *
 * Toujours mounted sur /operations/flotte (cf. metierNav).
 */
export const FlottePage = () => {
  const filiale = useAuthStore((s) => s.filiale);
  const metier  = filiale?.metier ?? 'generic';

  if (metier === 'transport_minier') return <FlotteCamionsPage />;
  // Béton : pas de toupies tant que le BPE n'est pas lancé (constants/activites.ts).
  if (!BPE_EN_SERVICE) {
    return (
      <div style={{ padding: 48, textAlign: 'center', fontSize: 13, color: 'var(--tx-3)' }}>
        Activité BPE non lancée — aucune flotte de toupies à gérer pour le moment.
      </div>
    );
  }
  return <FlotteToupiesPage />;
};
